<template>
  <div>
    <b-nav-item-dropdown
      right
      toggle-class="d-flex align-items-center dropdown-user-link"
      class="dropdown-user"
    >
      <template #button-content>
        <div
          class="d-sm-flex d-none user-nav mr-1"
          :class="{ 'user-nav-with-group': primaryGroup }"
        >
          <p class="user-name font-weight-bolder mb-0">
            {{ userDisplayName }}
          </p>
          <span v-if="primaryGroup" class="user-group-name">
            {{ primaryGroup.name }}
          </span>
          <span :class="primaryGroup ? 'user-group-name' : 'user-status'">{{ profileType }}</span>
        </div>
        <b-avatar
          size="40"
          :src="userData.image"
          variant="light-primary"
          badge
          class="badge-minimal"
          badge-variant="success"
          v-b-tooltip.hover.button.viewport="`${$t('profile', 1)}`"
        >
          <feather-icon v-if="!userData.image" icon="UserIcon" size="22" />
        </b-avatar>
      </template>
      <div>
        <b-dropdown-item link-class="d-flex align-items-center" @click="isView = true; clickAdministrator = true" v-if="$can('download_administrator_manual', 'User')">
          <feather-icon size="16" icon="BookIcon" class="mr-50" />
          <span>{{ $t("user_manual") }}</span>
        </b-dropdown-item>
      </div>
      <div>
        <b-dropdown-item link-class="d-flex align-items-center" @click="openOperatorManual" v-if="$can('download_operator_manual', 'User')">
          <feather-icon size="16" icon="BookIcon" class="mr-50" />
          <span>{{ $t("user_manual") }}</span>
        </b-dropdown-item>
      </div>
      <div v-if="userData.video_wall === 1">
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logoutVideoWall()"
        >
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>{{ $t("logout") }}</span>
        </b-dropdown-item>
      </div>
      <div v-else>
        <b-dropdown-item
          :to="{ name: 'user_profile' }"
          link-class="d-flex align-items-center"
          v-if="$can('read_profile', 'User')"
        >
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <span>{{ $t("profile") }}</span>
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item link-class="d-flex align-items-center" @click="logout()">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>{{ $t("logout") }}</span>
        </b-dropdown-item>
      </div>
    </b-nav-item-dropdown>
    <template>
      <div v-if="isView" class="modal-overlay">
        <div class="modal-content">
          <b-button @click="isView = false; clickOperator = false; clickAdministrator = false" class="close-button">X</b-button>
          <iframe
           v-if="clickAdministrator"
            src="manuales/Manual base de configuración.pdf"
            width="100%"
            height="500px"
          ></iframe>
          <iframe
             v-if="clickOperator"
            src="manuales/Manual_usuario_operador.pdf"
            width="100%"
            height="500px"
          ></iframe>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import { initialAbility } from "@/libs/acl/config";
import usePassport from "@/auth/passport/usePassport";
import { avatarText } from "@core/utils/filter";
import store from "@/store";
import axios from '@/libs/axios';

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    let isView = false;
    let clickOperator = false;
    let clickAdministrator = false;

    return {
      avatarText,
      isView,
      clickOperator,
      clickAdministrator,
    };
  },
  computed: {
    userData() {
      return this.$store.state.user.user;
    },
    primaryGroup() {
      return Array.isArray(this.userData.groups) && this.userData.groups.length
        ? this.userData.groups[0]
        : null;
    },
    userDisplayName() {
      return (
        this.userData.fullName ||
        this.userData.username ||
        this.userData.user ||
        this.userData.email
      );
    },
    profileType() {
      return (
        this.primaryGroup?.profile?.type ||
        this.userData.role ||
        this.userData.profile?.type ||
        ""
      );
    },
    userMustCloseShift() {
      return localStorage.getItem('user_must_close_shift') === 'true';
    }
  },
  mounted() {
    this.$root.$on("hotkey:operator-user-manual", this.openOperatorManual);

    setTimeout(() => {
      console.log("============================== WS ==============================");

      this.connectPresenceChannel();
      store.dispatch("grid/setOperationalSecurityWS");
      store.dispatch("grid/setAlarmsWS");
      store.dispatch("grid/setShowAlarmViewWS");
      store.dispatch("grid/setTakenAlarmWs");
      store.dispatch("grid/setShowUserViewWS");
      store.dispatch("grid/setActionPlanWS");
      store.dispatch("grid/setUserSetUp");
      store.dispatch("grid/setUpdateDeviceStatusWS");
      store.dispatch("grid/setSubsystemTreeMaintenanceWS");
    }, 5000);
  },
  beforeDestroy() {
    this.$root.$off("hotkey:operator-user-manual", this.openOperatorManual);
  },
  methods: {
    openOperatorManual() {
      this.clickAdministrator = false;
      this.clickOperator = true;
      this.isView = true;
    },
    async logout() {
      //Close user shift
      if (this.userMustCloseShift) {
        await this.userShiftClose();
      }

      if (!this.userData.is_master_admin || !this.userData.is_super_admin) {
        await this.releasePendingUserAlarms();
      }

      // Remove userData from localStorage
      localStorage.removeItem(usePassport.passportConfig.storageTokenKeyName);
      localStorage.removeItem(usePassport.passportConfig.storageRefreshTokenKeyName);
      window.Echo.disconnect();
      window.abortController.abort();
      window.abortController = new AbortController();

      // Remove userData from localStorage
      localStorage.removeItem("userData");
      localStorage.removeItem("shift_register");
      localStorage.removeItem("user_must_close_shift");
      localStorage.removeItem("additionalTokenImage");

      // clear all data in vuex
      for (const [key, value] of Object.entries(this.$store._actions)) {
        if (key.endsWith("/clear")) this.$store.dispatch(key);
      }

      // Reset ability
      this.$ability.update(initialAbility);

      document.location.reload();

      // Redirect to login page
      // this.$router.push({ name: "auth-login" });
    },
    async userShiftClose() {
      await axios.put(`v1/user-shifts/${this.userData.id}/close-shift`);
    },
    async releasePendingUserAlarms() {
      await axios.post(`v1/alarms/workflow/release-on-logout`);
    },
    logoutVideoWall() {
      store
        .dispatch("video_wall/updateVideoWallUserStatus", {
          id_user: this.userData.id,
          status: "offline",
        })
        .then(() => {
          // Remove userData from localStorage
          localStorage.removeItem(usePassport.passportConfig.storageTokenKeyName);
          localStorage.removeItem(usePassport.passportConfig.storageRefreshTokenKeyName);
          window.Echo.disconnect();
          window.abortController.abort();
          window.abortController = new AbortController();

          // Remove userData from localStorage
          localStorage.removeItem("userData");

          // clear all data in vuex
          for (const [key, value] of Object.entries(this.$store._actions)) {
            if (key.endsWith("/clear")) this.$store.dispatch(key);
          }

          // Reset ability
          this.$ability.update(initialAbility);

          // Redirect to login page
          this.$router.push({ name: "auth-login" });
        })
        .catch((response) => console.log(response));
    },
    connectPresenceChannel() {
      window.Echo.join("users");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background: white;
  padding: 20px;
  width: 80%;
  max-width: 800px;
  border-radius: 8px;
  position: relative;
}
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  background-color: #ff4d4d;
  color: white;
  font-size: 18px;
  font-weight: bold;
  border: none;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}

.close-button:hover {
  background-color: #ff1a1a;
}

.user-nav-with-group {
  height: 40px;
  justify-content: center;
  line-height: 1;
}

.user-group-name {
  max-width: 240px;
  overflow: hidden;
  font-size: 0.6rem;
  font-weight: 100;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-nav-with-group .user-status {
  font-size: 0.6rem;
  line-height: 0.7rem;
}
</style>
